import React, { Component } from 'react';
import { Button } from 'reactstrap';
import SignatureCanvas from 'react-signature-canvas';
import FontAwesome from 'react-fontawesome';

class Signature extends React.Component{

  constructor(props) {
    super(props);
    this.sigCanvas = React.createRef();
  }

  save(e){
    if(!this.sigCanvas.isEmpty()){
        this.props.onSaveClicked(this.sigCanvas.toDataURL()); //toData
    }else{
        alert('לא ניתן לשמור חתימה ריקה!');
    }
  }

  getSignatureData(){
    if(!this.sigCanvas.isEmpty()){
      return this.sigCanvas.toDataURL();
    }else{
        return null;
    }
  }

  render(){
    return(
      <div>
        
        <SignatureCanvas ref={(ref) => {this.sigCanvas = ref}} penColor="blue" canvasProps={{width:300, height:100, className:'sigCanvas' }}/>
        <br/>
        <Button onClick={(e) => this.save(e)} color="warning"><FontAwesome name="signature"/> שמור</Button>
        <Button onClick={(e) => {this.sigCanvas.clear()}} style={{marginRight:'1rem'}} color="secondary"><FontAwesome name="times"/> נקה</Button>
      </div>
    );
  };
}

export default Signature;